//Cancel out the annoying formats for the phone-number
//https://stackoverflow.com/questions/3736807/how-do-i-remove-the-blue-styling-of-telephone-numbers-on-iphone-ios
export const meta = (meta) => {
  meta.addMetaItem([
    //<meta name="format-detection" content="telephone=no">
    { name:'format-detection', content: 'telephone=no' },
    { name:"color-scheme", content:"only light" }
  ])
  meta.addBodyAttribute([
    { name: 'tabindex', value:'-1' }
  ])
}

export const extraJS = [

  //We're going to add some code which is going to create the google translation widget if the element exists
  //or otherwize it's going to add a function to the window context which will get acquired by the nav bar
  { head:false, code:`function googleTranslateElementInit() { 
      if(typeof window !== 'undefined') {

        const makeTheTranslationInstance = () => {
          try {
            new google.translate.TranslateElement({ pageLanguage: 'en' }, 'google_translate_element');
          } catch(e) {
            console.log("NOTICE 483957 Unable to make google translation element") 
          }
        }

        const tryToMakeInstance = () => {
          if(document.getElementById('google_translate_element')) {
            makeTheTranslationInstance()
            return true
          }
          return false
        }

        let timer = setInterval(() => {
          if(tryToMakeInstance()) {
            clearInterval(timer)
            timer = null
          }
        }, 500)
      } 
    }`
  },

  { head:false, src:"/google-translate" },
]

/*

function googleTranslateElementInit() { 
      if(typeof window !== 'undefined') {

        const makeTheTranslationInstance = () => {
          new google.translate.TranslateElement({ pageLanguage: 'en' }, 'google_translate_element');
        }

        if(document.getElementById('google_translate_element')) {
          makeTheTranslationInstance()
        } else {
          window.MAKE_TRANSLATION_INSTANCE = makeTheTranslationInstance
        }

      } 
    }

*/

//We need to include this. There should be a separate one for 
//https://csswizardry.com/2020/05/the-fastest-google-fonts/

export const externalCSS = [
  // {type:'webfont', href:'https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;900'},
  // {type:'webfont', href:'https://fonts.googleapis.com/css2?family=Source+Serif+Pro:wght@700&display=swap'},
  // {type:'webfont', href:"https://fonts.googleapis.com/css2?family=Oswald:wght@500&display=swap"},
  //{ type:'css', href:'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css' },
  { type:'webfont', href:"https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap" },
  { type:'webfont', href:"https://fonts.googleapis.com/css?family=Overpass%3A400%2C400i%2C700&ver=6.8.2" },
  { type:'css', href:"https://use.typekit.net/qrn0pdk.css" }
]

